export const textColumnFilter = {
    filter: "agMultiColumnFilter",
    filterParams: {
        filters: [
            {
                filter: "agTextColumnFilter",
                filterParams: {
                    buttons: ["reset"]
                }
            },
            {
                filter: "agSetColumnFilter",
                filterParams: {
                    buttons: ["reset"]
                }
            }
        ]
    },
};